export default "__VITE_ASSET__DBISqzB9__"